import React from "react"
import Status from "components/atoms/Status/Status"
import Tags from "components/shared/Tags"
import { useNavigate } from "react-router-dom"
import { AdminOfferType } from "services/api-service/types"
import styled from "styled-components"
import { Box, Row } from "ui/components/atoms/_atoms"
import { IconButton } from "ui/components/atoms/button"
import Tag from "ui/components/atoms/tag"
import { LabelH2 } from "ui/components/atoms/typography"
import { translate } from "ui/data"
import { adSystemIcon, adSystemLabel } from "utils/adSystems"

const AdminProfileBlock = ({ data }: { data: AdminOfferType }) => {
  const navigate = useNavigate()

  return (
    <Wrapper>
      <Content>
        <Box>
          <Row $justifyContent="space-between" $marginBottom="XS">
            <Row $alignItems="center">
              <Status label={data.status} $marginRight="XS" />
              <LabelH2 $marginBottom="0" $marginTop="0">
                {data.name}
              </LabelH2>
            </Row>
            <IconButton
              icon="edit"
              $background="none"
              onClick={() => navigate(data.id)}
              ariaLabel="Go back"
            />
          </Row>
          <Tags>
            <Tag
              $type="secondary"
              $showBorder={false}
              $background="background"
              icon="user"
              $iconColor="primary"
              label={data.profile.name}
            />
            {data && (
              <Tag
                $type="secondary"
                $showBorder={false}
                $background="background"
                icon="tag"
                $iconColor="primary"
                label={`${translate(data.category)} / ${translate(data.subcategory)}`}
              />
            )}
            {(data.activeAdSystems ?? []).map(system => (
              <Tag
                key={system}
                $type="secondary"
                $showBorder={false}
                $background="background"
                icon={adSystemIcon(system)}
                $iconColor="primary"
                label={adSystemLabel(system)}
              />
            ))}
          </Tags>
        </Box>
      </Content>
    </Wrapper>
  )
}

export default AdminProfileBlock

const Content = styled(Box)``

const Wrapper = styled(Box)`
  padding: ${({ theme }) => theme.space.S};
  border-radius: ${({ theme }) => theme.variable.borderRadius};
  border: 1px solid ${({ theme }) => theme.color.border};
  background: white;
`
